import { render, staticRenderFns } from "./SystemCustomNotifications.vue?vue&type=template&id=d7b442d4"
import script from "./SystemCustomNotifications.vue?vue&type=script&lang=js"
export * from "./SystemCustomNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports